import { Validation } from '@philips-emr/tws-core/lib/services/model-service';

const EQUALS = 'equals';

function equalsValidator(value: string, equals: string): Validation[] {
  const valid = equals === value;

  return [{
    message: !valid ? 'beneficiary.valor-diferente' : '',
    name: EQUALS,
    valid,
  }];
}

export {
  EQUALS,
  equalsValidator,
};
